import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./Modal.css";
import Button from "../../Components/UIComponents/Button";
const StatusChangeModal = (props) => {
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="modal-main-wrapper">
            <div className="confirmation-modal-wrap">
              <h3>{props.type}</h3>
              <div className="modal-confirmation-button">
                <Button
                  extraClass="confirm-btn"
                  label="Confirm"
                  onClick={() => props.handleOnClick()}
                  isLoading={props.isLoading}
                />
                <button className="cancel-btn" onClick={() => props.onHide()}>
                  Cancel
                </button>
              </div>
            </div>

            <div className="modal-side-image-wrap">
              <img src="./images/modal-side-img.png" alt="img" />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default StatusChangeModal;
